import { TooltipButton } from "~/components/ui/button"
import { BellIcon, BellOffIcon } from "lucide-react"
import { toast } from "sonner"
import { api } from "~/trpc/react"

import { TooltipProvider } from "../ui/tooltip"

export function IssueWatchButton({
	issueId,
	teamId
}: {
	issueId: string
	teamId: string
}) {
	const utils = api.useUtils()
	const watchState = api.issues.getWatchState.useQuery(
		{ issueId, teamId },
		{ enabled: !!issueId && !!teamId }
	)
	const setWatchState = api.issues.setWatchState.useMutation({
		onSuccess: async (_watcher, variables) => {
			await utils.issues.getWatchState.invalidate({
				issueId: variables.issueId,
				teamId: variables.teamId
			})
			toast.success(variables.watching ? "Watching issue" : "Unwatched issue")
		},
		onError: () => toast.error("Failed to update watch state")
	})
	const watching = watchState.data?.watching ?? false

	return (
		<TooltipProvider>
			<TooltipButton
				variant="outline"
				size="icon"
				aria-label={watching ? "Unwatch issue" : "Watch issue"}
				disabled={watchState.isLoading || setWatchState.isPending}
				onClick={() =>
					setWatchState.mutate({
						issueId,
						teamId,
						watching: !watching
					})
				}
				tooltip={watching ? "Unwatch issue" : "Watch issue"}
			>
				{watching ? (
					<BellIcon className="size-4 text-orbit-text" />
				) : (
					<BellOffIcon className="size-4" />
				)}
			</TooltipButton>
		</TooltipProvider>
	)
}
